import { Outcome } from "./Outcome";

export function ContactSent() {
  return (
    <Outcome chip="Received" chipTone="green" title="Thanks — that is logged.">
      <p>
        We read every enquiry ourselves and reply within one working day,
        usually with a question or two before we start the clock.
      </p>
    </Outcome>
  );
}
